import { useConsultDoctorContext } from "../Contexts/ConsultDoctorContext";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { baseUrl } from "../utilities/configurations";
import apiRequest from "../utilities/request";
import { ScrollBar } from "./ScrollBar";
import PropTypes from "prop-types";
import { useEffect } from "react";

function SearchDoctor(props){
  const {
    setSelectedDoctorBySearch,
    setSelectedSpecialization,
    setAllDoctorsFromBranch,
    selectedDoctorBySearch,
    selectedSpecialization,
    allDoctorsFromBranch,
    specializationsData,
    setShowDoctorsModal,
    searchDoctor,
  } = useConsultDoctorContext();

  const {isLoading, setIsLoading} = props;

  const fetchDoctorsBySpecialization = async (data) => {
    try {
      const response = await apiRequest(
        `${baseUrl}/consult/physicians?specializationId=${data.id}`,
        "GET"
      );
      if (response.data && Array.isArray(response.data)) {
        // Check if data exists and is an array
        const doctorsWithSpecialization = response.data
          .map((doctor) => ({
            ...doctor,
            specializationId: data.id, // Add the specialization ID to each doctor object
            specializationName: data.name, // Add the specialization name to each doctor object
          }))
          .filter((item) =>
            item.specializationName.toLowerCase().includes("consultation")
          );
        setAllDoctorsFromBranch((prevData) => [
          ...prevData,
          ...doctorsWithSpecialization,
        ]);
      } else {
        console.log(`No valid data found for specialization: ${data.id}`);
      }
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  const handleSelectDoctor = (doctor) => {
    setSelectedDoctorBySearch(doctor);

    //add specialization if there's no specialization selected (for calendar id)
    let index = specializationsData.findIndex(e=>e.id === doctor.specializationId)
    if(index>=0){
      setSelectedSpecialization(specializationsData[index]);
    }
    setShowDoctorsModal(false);
  };

  const getDoctors = async()=>{
    setIsLoading(true);
    setAllDoctorsFromBranch([]);
    try {
      if(selectedSpecialization){
        fetchDoctorsBySpecialization(selectedSpecialization);
      }else{
        specializationsData.forEach((data) => {
          fetchDoctorsBySpecialization(data);
        })
      }
    } catch (error) {
      console.error("Error fetching specializations:", error);
    } finally {
      //for refresh purposes of doctors list
      setTimeout(() => {
        setIsLoading(false);
      }, 0);
    }
  }

  useEffect(()=>{
    getDoctors();
  },[selectedSpecialization])

  let doctors = allDoctorsFromBranch;
  if(searchDoctor && !selectedSpecialization){
    doctors = allDoctorsFromBranch.filter((data) =>
      data.name.toLowerCase().includes(searchDoctor?.toLowerCase())
    );
  }else if(selectedSpecialization && !searchDoctor){
    doctors = allDoctorsFromBranch?.filter(
      (data) => data.specializationId === selectedSpecialization?.id
    );
  }else if(selectedSpecialization && searchDoctor){
    doctors = allDoctorsFromBranch.filter(
      (data) =>
        data.name.toLowerCase().includes(searchDoctor?.toLowerCase()) &&
        data.specializationId === selectedSpecialization?.id
    );
  }

  let content = doctors.map((data) => (
    <div key={data.specializationId} className="flex flex-row mb-2">
      <label id="labl" className="w-full cursor-pointer">
        <input
          name="doctor"
          id="doctor"
          type="radio"
          onChange={() => handleSelectDoctor(data)}
          checked={
            data.id &&
            data.specializationId === selectedDoctorBySearch?.id &&
            selectedDoctorBySearch?.specializationId
          }
        />
        <div className=" w-full text-sm p-3 border rounded-lg">
          <p>{data.name}</p>
          <p>
            {data.specializationName.substring(
              data.specializationName.indexOf(":") + 1
            )}
          </p>
        </div>
      </label>
    </div>
  ))

  if(isLoading){
    content = null;
  }

  return (
    <ScrollArea.Root className="w-full rounded overflow-hidden bg-white">
      <ScrollArea.Viewport className="w-full sm:h-72 h-[70vh] rounded">
        {content}
      </ScrollArea.Viewport>
      <ScrollBar />
    </ScrollArea.Root>
  );
};

SearchDoctor.propTypes = {
	isLoading: PropTypes.bool,
  setIsLoading: PropTypes.func
};

export default SearchDoctor;